module.exports = __webpack_public_path__ + "images/186_320.jpg";